import type { ActionButtonProps } from "./action-button.type";

import { Button } from "antd";
import { useTranslation } from "react-i18next";

import { getActionButtonIcon } from "./action-button.helper";

export const ActionButton = ({
  action,
  noIcon,
  children,
  ...buttonProps
}: ActionButtonProps) => {
  const { t } = useTranslation();
  const icon = noIcon ? undefined : getActionButtonIcon(action);

  return (
    <Button icon={icon} {...buttonProps}>
      {children ?? t(`global:action.${action}`)}
    </Button>
  );
};
